import React from 'react';

import { Heading, PropertyGroup } from '../../../../components';

import css from '../../../../containers/ListingPage/ListingPage.module.css';

const createFilterOptions = options => options.map(o => ({ key: `${o.option}`, label: o.label }));

const MarketsEventsWithIcons = ({ listing, listingConfig }) => {
  const marketsEventsSelectedValues = listing.attributes.publicData.markets_events;
  const fieldConfig = listingConfig.listingFields.find(c => c.key === 'markets_events');

  if (!marketsEventsSelectedValues || !fieldConfig) return null;

  const { enumOptions, showConfig } = fieldConfig;

  return (
    <div className={css.sectionMultiEnum}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {showConfig.label}
      </Heading>
      <PropertyGroup
        id="markets_events"
        options={createFilterOptions(enumOptions)}
        selectedOptions={marketsEventsSelectedValues}
        twoColumns={enumOptions.length > 5}
      />
    </div>
  );
};

export default MarketsEventsWithIcons;
